import React from 'react'
import { IconBase, OptionalIconBaseProps } from '../components/IconBase'

export const FlagIcon = (props: OptionalIconBaseProps) => (
  <IconBase name="flag" viewBox="0 0 24 24" {...props}>
    <path d="M12.36,6L12.76,8H18V14H14.64L14.24,12H7V6H12.36M14,4H5V21H7V14H12.6L13,16H20V6H14.4" />
  </IconBase>
)
